import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col justify-center bg-[#003366] text-white overflow-hidden pt-20 pb-16 px-4" data-id="element-163">
      {/* Abstract City Lights Effect */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-164" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#FF6600]/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-165" />

      <div className="relative z-10 max-w-6xl mx-auto w-full grid md:grid-cols-2 gap-12 items-center" data-id="element-166">
        {/* Copy Column */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="space-y-8" data-id="element-167">
          <div className="inline-flex items-center space-x-2 bg-[#002244]/50 rounded-full px-4 py-1.5 border border-[#004488]" data-id="element-168">
            <span className="w-2 h-2 rounded-full bg-[#99CC33] animate-pulse" data-id="element-169" />
            <span className="text-sm font-medium text-slate-300" data-id="element-170">
              Para hispanos en USA
            </span>
          </div>

          <h1 className="text-4xl md:text-6xl font-bold leading-tight tracking-tight" data-id="element-171">
            Deja de traducir. <br data-id="element-172" />
            <span className="text-[#FF6600]" data-id="element-173">Empieza a responder.</span>
          </h1>

          <div className="space-y-4 text-lg text-slate-300 border-l-4 border-[#FF6600] pl-6 py-2 bg-[#002244]/30 rounded-r-lg" data-id="element-174">
            <p className="italic" data-id="element-175">Hay un momento que se repite.</p>
            <p data-id="element-176">Te hablan en inglés. Tú entiendes… más o menos.</p>
            <p data-id="element-177">Y justo cuando toca responder, tu mente hace esto:</p>
            <p className="font-medium text-white" data-id="element-178">
              Traduces. Armas la frase. Te tardas.
            </p>
            <p data-id="element-179">
              Y terminas con el mismo cierre de siempre:{' '}
              <span className="text-[#FF6600]" data-id="element-180">"Yeah… ok… sorry…"</span>
            </p>
          </div>

          <div className="space-y-4" data-id="element-181">
            <div className="flex flex-col sm:flex-row gap-4 pt-4" data-id="element-182">
              <Button href="#precio-card" size="lg" className="w-full sm:w-auto text-lg group" data-id="element-183">
                Quiero hablar fluido
                <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-184" />
              </Button>
              <p className="text-sm text-slate-400 mt-2 sm:mt-0 sm:ml-4 flex items-center" data-id="element-185">
                <CheckCircle2 className="h-4 w-4 mr-2 text-[#99CC33]" data-id="element-186" />
                Resultados en 14 días
              </p>
            </div>

            <p className="text-sm text-slate-400" data-id="element-187">
              Más de 10,000 hispanos ya mejoraron su fluidez
            </p>
          </div>
        </motion.div>

        {/* Image Column */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative" data-id="element-188">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-blue-900/20 border border-[#004488] bg-[#002244]" data-id="element-189">
            <img src="https://cdn.magicpatterns.com/uploads/kDvu13gswqkhmpNp4GLCHG/ingles_nativo_en_14_dias_.png" alt="Inglés Nativo en 14 Días Product Mockup" className="w-full h-auto object-cover" data-id="element-190" />

            {/* Floating Badge */}
            <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            delay: 0.6,
            type: 'spring'
          }} className="absolute -bottom-6 -left-6 md:bottom-8 md:-left-8 bg-white text-[#003366] p-4 rounded-xl shadow-xl border border-slate-100 max-w-[200px] hidden md:block" data-id="element-191">
              <p className="font-bold text-lg leading-tight" data-id="element-192">
                20 Escenas Reales
              </p>
              <p className="text-sm text-slate-600" data-id="element-193">
                Vida diaria, trabajo y trámites en USA
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}